module.exports = __webpack_public_path__ + "static/media/union-cover.e95c655d.jpg";